import { render, staticRenderFns } from "./GerenciaCadastroAvaliacao.vue?vue&type=template&id=79ca91f9"
import script from "./GerenciaCadastroAvaliacao.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports